const messages = {
  title: "Marketing-Einwilligungen",
  required: "Erforderlich",
  answered: "✓ Beantwortet",
  read: "Gelesen",
  notRead: "Nicht gelesen",
  alreadyAnswered: "Bereits beantwortet",
  requiredQuestionsMustBeAccepted:
    "{count} erforderliche Frage(n) müssen akzeptiert werden",
  pleaseAnswerQuestions: "Bitte beantworten Sie die folgenden Fragen:",
  iAccept: "Ich akzeptiere",
  scrollToUnlock: "Zum Aktivieren nach unten scrollen",
  fieldRequired: "Dieses Feld ist erforderlich",
  scrollToContinue: "↓ Zum Fortfahren nach unten scrollen",
  saving: "Wird gespeichert...",
  saveConsents: "Einwilligungen speichern",
  allRequiredAccepted: "✓ Alle erforderlichen Fragen akzeptiert",
  requiredConsentsCompleted:
    "{completed}/{total} erforderliche Einwilligungen ausgefüllt",
  selectConsentToView:
    "Wählen Sie eine Einwilligung aus der Liste, um den Inhalt anzuzeigen",
  readAllContentFirst: "Bitte lesen Sie zuerst den gesamten Inhalt: {names}",
  acceptAllRequiredIn:
    "Bitte akzeptieren Sie alle erforderlichen Fragen in: {names}",
  acceptAllBeforeSaving:
    "Bitte akzeptieren Sie alle erforderlichen Fragen vor dem Speichern.",
  failedToSave:
    "Einwilligungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.",
  errorSaving:
    "Beim Speichern der Einwilligungen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  failedToLoad:
    "Einwilligungen konnten nicht geladen werden. Bitte aktualisieren Sie die Seite.",
  viewPdf: "PDF anzeigen",
  requiredConsentTitle: "Erforderliche Einwilligung",
  acceptAndContinue: "Akzeptieren und fortfahren",
};

export default {
  messages,
};
